"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createLogicalCompositorWith_1 = __importDefault(require("./createLogicalCompositorWith"));
var orify = createLogicalCompositorWith_1.default('some');
exports.default = orify;
